import { defineMessages } from '@/i18n';

export const validationMessages = defineMessages({
  required: 'platform.app.validation.required',
  invalidEmail: 'platform.app.validation.email.invalid',
  greaterThan: 'platform.app.validation.greaterThan',
  maxDecimals: 'platform.app.validation.maxDigitsAfterDecimal',
  minUpload: 'platform.app.validation.minUpload',
  number: 'platform.app.validation.number',
  paswordLowercase: 'platform.app.validation.password.lowercase',
  paswordNotMatching: 'platform.app.validation.password.notMatching',
  passwordNumber: 'platform.app.validation.password.number',
  passwordShort: 'platform.app.validation.password.short',
  passwordSpecialChars: 'platform.app.validation.password.specialCharacters',
  passwordUppercase: 'platform.app.validation.password.uppercase',
});
